var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useTranslate, useGetManyReference } from 'ra-core';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import { useApiHub } from '../ApiHubContext';
export const ApiAssetsField = props => {
    const translate = useTranslate();
    const classes = useStyles(props);
    const { record } = props, rest = __rest(props, ["record"]);
    const { data, loaded, error } = useGetManyReference('assets', 'id', record.id, undefined, undefined, undefined, 'apis');
    if (!loaded) {
        return React.createElement(LinearProgress, null);
    }
    if (error) {
        return (React.createElement(Typography, Object.assign({ variant: "body1", className: classes.error }, rest), translate('ra.page.error')));
    }
    if (!data) {
        return (React.createElement(Typography, Object.assign({ variant: "body1" }, rest), translate('resources.apis.overview.notifications.no_assets')));
    }
    const links = Object.keys(data).map(key => {
        const { id, name, type, links } = data[key];
        return {
            id,
            name,
            type: type,
            href: get(links, '[0].href', null),
            rel: get(links, '[0].rel', null),
        };
    });
    return React.createElement(AssetsList, Object.assign({ record: record, links: links }, rest));
};
export const AssetsList = (_a) => {
    var { record, links } = _a, rest = __rest(_a, ["record", "links"]);
    const { urlWithTenant } = useApiHub();
    return (React.createElement(React.Fragment, null,
        React.createElement(List, Object.assign({}, rest), links.length > 0 &&
            links.map(link => (React.createElement(ListItem, { key: link.id, disableGutters: true },
                React.createElement(Link, { type: link.type, href: `${urlWithTenant}${link.href}`, download: link.name }, link.name))))),
        links.length > 1 ? React.createElement(DownloadFilesButton, { id: record.id }) : null));
};
const DownloadFilesButton = ({ id }) => {
    const translate = useTranslate();
    const { urlWithTenant } = useApiHub();
    const href = `${urlWithTenant}/api-management/1.0/apis/${id}/assets/archive`;
    const label = translate('resources.apis.overview.actions.download_assets');
    return (React.createElement(Link, { component: DownloadButton, href: href, download: "assets.zip", "aria-label": label }, label));
};
const DownloadButton = forwardRef((props, ref) => (React.createElement(Button, Object.assign({ variant: "outlined", color: "primary", ref: ref }, props))));
const useStyles = makeStyles(theme => ({
    error: {
        color: theme.palette.error.main,
        marginBottom: theme.spacing(),
    },
}), {
    name: 'Layer7ApiAssetsField',
});
//# sourceMappingURL=ApiAssetsField.js.map